export const Text = (props) => {
  const context = props.context

  const display = () => {
    if (props.display_condition) {
      return (
        context.inFormValues({ name: "reporter_type" })?.value ===
        props.display_condition
      )
    }
    return true
  }

  return display
    ? <div
        class={`text-content ${props.class ? props.class : ""}`}
        // biome-ignore lint/security: it's not dangerous in this case
        dangerouslySetInnerHTML={{ __html: props.body }}
      />
    : null
}
